import { Box } from '@mui/material'
import * as Fathom from 'fathom-client'
import React, { useEffect } from 'react'
import { BrowserRouter as Router } from 'react-router-dom'
import HeaderMain from '../components/headers/header-main/header-main'
import HeaderOnboarding from '../components/headers/header-onboarding/header-onboarding'
import RegisterHeader from '../components/headers/register-header'
import Page from '../components/pages/page'
import { ActionDataProvider } from '../context/action-data-context'
import { ActionSelectorProvider } from '../context/action-selector-context'
import { CandidateDataProvider } from '../context/candidate-data-context'
import { ColorModeProvider } from '../context/color-context'
import { LocationProvider } from '../context/location-context'
import { OnboardingPageProvider } from '../context/onboarding-context'
import { PageProvider } from '../context/page-context'
import Theme from '../context/theme-context'
import { AuthProvider } from '../state/auth-state'
import { FiltersProvider } from '../state/filters-state'
import { UserSearchProvider } from '../state/user-search-state'
import { initSegmentAnalytics, trackSegmentEvent } from '../utilities/analytics'
import { isInBrowser } from '../utilities/browser'
import { initGleap } from '../utilities/gleap'
import DefaultLayout from './default-layout'
import OnboardingLayout from './onboarding-layout'
import ResultsLayout from './results-layout'
import { GiveLivelyProvider } from '../context/give-lively-context'
import { DemocracyEngineProvider } from '../context/democracy-engine-context'

const Layout = props => {
  const RouterWrapper = isInBrowser() ? Router : Box
  // TODO: refactor this so all data is just in one context

  useEffect(() => {
    if (isInBrowser()) {
      if (process.env.GATSBY_GLEAP_API_KEY) {
        void initGleap()
      }

      if (process.env.NETLIFY_DEPLOY_CONTEXT == 'production') {
        Fathom.load('URZHUQPU')
        initSegmentAnalytics()
      }
    }
  }, [])

  /* TODO: Refactor this into one state provider template */

  return (
    <RouterWrapper>
      <AuthProvider>
        <LocationProvider>
          <ColorModeProvider>
            <Theme>
              <PageProvider>
                <FiltersProvider>
                  {/* TODO: UserSearchProvider should really be isolated to a community page template */}
                  <UserSearchProvider>
                    {/* TODO: A number of these should really be isolated to an action data template or integrated into the Results template */}
                    <ActionDataProvider>
                      <CandidateDataProvider>
                        <ActionSelectorProvider>
                          <DemocracyEngineProvider>
                            <GiveLivelyProvider>{<LayoutLookup {...props} />}</GiveLivelyProvider>
                          </DemocracyEngineProvider>
                        </ActionSelectorProvider>
                      </CandidateDataProvider>
                    </ActionDataProvider>
                  </UserSearchProvider>
                </FiltersProvider>
              </PageProvider>
            </Theme>
          </ColorModeProvider>
        </LocationProvider>
      </AuthProvider>
    </RouterWrapper>
  )
}

const layouts = {
  actions: props => (
    <ResultsLayout {...props} key="actions">
      {props.children}
    </ResultsLayout>
  ),
  explore: props => (
    <ResultsLayout {...props} key="explore">
      {props.children}
    </ResultsLayout>
  ),
  register: props => (
    <OnboardingLayout {...props} key="register">
      {props.children}
    </OnboardingLayout>
  ),
  onboarding: props => (
    <OnboardingLayout {...props} key="onboaring">
      {props.children}
    </OnboardingLayout>
  )
}

const headers = {
  register: RegisterHeader,
  onboarding: HeaderOnboarding
}

const contexts = {
  onboarding: OnboardingPageProvider
}

const LayoutLookup = props => {
  const layout = props.pageContext.layout
  const Layout = (layout && layouts[layout]) || DefaultLayout
  const Header = (layout && headers[layout]) || HeaderMain
  const ContextProvider = layout && contexts[layout]

  return ContextProvider ? (
    <ContextProvider>
      <Page Header={Header}>
        <Layout>{props.children}</Layout>
      </Page>
    </ContextProvider>
  ) : (
    <Page Header={Header}>
      <Layout>{props.children}</Layout>
    </Page>
  )
}

export default Layout
